<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-autocomplete
          v-model="entry.customer"
          :items="items"
          :loading="autocomplete.isLoading"
          :search-input.sync="autocomplete.search"
          color="black"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="name"
          :label="$vuetify.t('$vuetify.lobis.selectCustomer')"
          :placeholder="$vuetify.t('$vuetify.lobis.queryCustomer')"
          prepend-icon="mdi-database-search"
          return-object
        ></v-autocomplete>
      </v-flex>
      <v-divider></v-divider>
      <div v-if="entry.customer">
        <v-flex xs12>
          <v-text-field
            :name="$vuetify.t('$vuetify.lobis.duration')"
            :label="$vuetify.t('$vuetify.lobis.duration')+' in Minuten'"
            id="id"
            v-model="entry.duration"
            type="number"
          ></v-text-field>
        </v-flex>
        <v-divider></v-divider>
        <v-flex xs12>
          <v-textarea
            label="Beschreibung"
            v-model="entry.description"
          ></v-textarea>
      </v-flex>
      <v-btn
        color="primary"
        dark
        @click="save()"
      >Speichern</v-btn>
      </div>
    </v-layout>
  </div>
</template>

<script>
import apiCall from '../../../utils/api'
import { CALL_SAVE } from '../../../store/actions/call'

export default {
  data () {
    return {
      autocomplete: {
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        search: null
      },
      entry: {
        id: null,
        customer: null,
        duration: null,
        description: ''
      }
    }
  },
  computed: {
    items () {
      return this.autocomplete.entries.map(entry => {
        const Description = entry.name

        return Object.assign({}, entry, { Description })
      })
    }
  },
  created () {
  },
  watch: {
    'autocomplete.search' (val) {
      // Items have already been requested
      if (this.autocomplete.isLoading) return

      this.autocomplete.isLoading = true

      // Lazily load input items
      apiCall({ url: 'api/customers', method: 'POST', q: val }).then(resp => {
        this.autocomplete.entries = resp
      }).catch(err => {
        console.log(err)
      }).finally(() => (this.autocomplete.isLoading = false))
    }
  },
  methods: {
    save () {
      this.$store.dispatch(CALL_SAVE, this.entry).then(resp => {
        this.$swal({
          type: 'success',
          title: 'Eintrag erfolgreich hinzugefügt!',
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push({ name: 'Calls' })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Service/Call/Create.vue